import './index.scss'
import { useEffect, useState } from 'react'
import AnimatedLetters from '../AnimatedLetters'
import Loader from 'react-loaders'

const Projects = () => {
    const [letterClass, setLetterClass] = useState('text-animate')

    useEffect(() => {
        setTimeout(() => {
        setLetterClass('text-animate-hover')
        }, 3000)
    }, [])
    
    return (
        <>
        <div className="container projects-page">
            <div className="text-zone">
            <h1>
                <AnimatedLetters
                    letterClass={letterClass}
                    strArray={['P', 'r', 'o', 'j', 'e', 'c', 't', 's']}
                    idx={8}
                />
            </h1>
            
                <div className="row">
                    <div className="column">

                        <div className="project-card">
                            <div className="card-title">
                                IIITB CMS
                            </div>

                            <div className="card-header"><b>Tech Stack: </b>Java Springboot, Angular JS, Maven, Git/GitHub, ELK Stack, Docker, Ansible, Jenkins</div>
                            
                            <br />
                            <div className="card-body">
                                
                            As it happens in many institutions, the students, faculty, and staff have numerous and varied concerns, which need to be projected towards the appropriate committee for resolution. This project aims towards building a comprehensive system that takes care of the above and mitigates the need for maintaining separate mailboxes.  
                                
                            </div>

                            <a href="https://google.com" target="_blank" rel="noreferrer" className="card-button">Code</a>
                            
                        </div>

                    </div>
                    <div className="column">

                        <div className="project-card">
                            <div className="card-title">
                                Banking System
                            </div>

                            <div className="card-header"><b>Tech Stack: </b>C, Linux</div>
                            
                            <br />
                            
                            <div className="card-body">
                                
                                A conceptual model of a simple banking system that uses concepts of Operating Systems like threading, locking etc. to enable addition/deletion of users, creation/termination of single/joint accounts and functions like deposit/withdrawl/query on accounts.  
                                
                            </div>

                            <a href="https://google.com" target="_blank" rel="noreferrer" className="card-button">Code</a>
                            
                        </div>

                    </div>
                    <div className="column">

                        <div className="project-card">
                            <div className="card-title">
                                Driver Behavior Profiling
                            </div>

                            <div className="card-header"><b>Tech Stack: </b>Machine Learning, Android, Google Sheets, Google Forms</div>
                            
                            <br />

                            <div className="card-body">
                                
                                This project derives a comprehensive profile of the driver by obtaining data from sensors of the smart phone in the vehicle and harnesses the power of Machine Learning to predict the nature of driving. Upon obtaining the results, appropriate actions can be taken. Also, the results are shown in a mobile app.
                                
                            </div>

                            <a href="https://google.com" target="_blank" rel="noreferrer" className="card-button">Code</a>
                            
                        </div>

                    </div>

                </div>

                <br />

                <div className="more-tag">
                    <h2>
                    <AnimatedLetters
                        letterClass={letterClass}
                        strArray={['.', '.', '.', 'a', 'n', 'd', ' ', 'm', 'o', 'r', 'e', ' ', 'o', 'n', ' ', 'm', 'y', ' ']}
                        idx={7}
                    />

                    <a href="https://github.com/akshathkaushal" target="_blank" rel="noreferrer" className="more-github">
                    {/* <AnimatedLetters
                        letterClass={letterClass}
                        strArray={['G', 'i', 't', 'H', 'u', 'b']}
                        idx={10}
                    /> */}
                    GitHub
                    </a>

                    </h2>
                </div>
            </div>

        </div>
        <Loader type="pacman" />
        </>
    )
}

export default Projects